import React from 'react';
import PublicLayout from '../components/shared/Layout/public/Layout';

const PublicRoute = ({ component: Component }: any) => {
    return (
        <PublicLayout>
            <Component />
        </PublicLayout>
    );
};
export default PublicRoute;
